import React, { useState, useRef, useEffect } from 'react';
import styles from './seasonSelector.module.css';
import {NavLink} from "react-router-dom";

interface TournamentOtherSeasons {
    id: number;
    name: string;
    short_name: string;
    fk_parent: number;
    fk_season: {
        name: string;
    };
}

interface SeasonSelectorProps {
    currentSeason: string;
    seasons: TournamentOtherSeasons[];
    onSeasonChange?: (season: TournamentOtherSeasons) => void;
}

const SeasonSelector: React.FC<SeasonSelectorProps> = ({ currentSeason, seasons }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSeasonSelect = (season: TournamentOtherSeasons) => {

        setIsOpen(false);
    };

    return (
        <div className={styles.seasonSelector} ref={dropdownRef}>
            <button onClick={toggleDropdown} className={styles.seasonToggle}>
                {currentSeason} &#9660;
            </button>
            {isOpen && (
                <ul className={styles.seasonDropdown}>
                    {seasons.map((season) => (
                        <li key={season.id}>
                            {/*<button onClick={() => handleSeasonSelect(season)}>*/}
                                <NavLink to={'/tournaments/' + String(season.id)}>{season.fk_season.name}</NavLink>
                            {/* </button>*/}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SeasonSelector;